import "./LoginPage.less";

import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { IBaseProps } from "lib/data/interfaces";
import { LoginService } from "lib/services/LoginService";
import { Event, EventDispatcher } from "lib/EventDispatcher";

import { LoginView } from "components/views";


interface ILoginPageProps extends IBaseProps, RouteComponentProps<any> {

}

interface ILoginPageState {

}

export class LoginPage extends React.Component<ILoginPageProps, ILoginPageState> {

	public static readonly BasePath: string = "/login";

	public constructor(props: ILoginPageProps) {
		super(props);

		this.state = {

		};
	}

	public componentWillMount() {

		// Register For Logged In Event
		EventDispatcher.register(Event.LoggedIn, this.onLogin);
	}

	public componentWillReceiveProps() {

		// Register For Logged In Event
		EventDispatcher.register(Event.LoggedIn, this.onLogin);
	}

	public componentWillUnmount() {

		// Unregister For Logged In Event
		EventDispatcher.unregister(Event.LoggedIn, this.onLogin);
	}

	public render() {

		return (

			<div className="login-page">

				<div className="login-wrapper">

					<div className="logo">
						<img src="https://rules.wyo.gov/assets/images-custom/wyominglogo-whitea.png" />
					</div>

					<LoginView />
				</div>
			</div >
		);
	}

	private onLogin = () => {

		// Ensure We're Still On The Login Page
		if (window.location.pathname.endsWith(LoginPage.BasePath)) {

			// Get Previous Location
			const previousLocation = LoginService.getPreviousLocation();

			// Check Previous Location
			if (previousLocation !== undefined) {

				// Navigate To Previous Location
				this.props.history.push(previousLocation);
			}
			else {

				this.props.history.push("/");
			}
		}
		else {

			// Unregister For Logged In Event
			EventDispatcher.unregister(Event.LoggedIn, this.onLogin);
		}
	}
}
